/* eslint-disable */
import type { ResponseContext } from "./ResponseContextProto.pb";

/** Response to a request to set a customer's notification preference. */
export interface SetNotificationPreferenceResponse {
  status?: SetNotificationPreferenceResponseStatus;
  response_context?: ResponseContext;
}

export enum SetNotificationPreferenceResponseStatus {
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
  UNAUTHENTICATED = "UNAUTHENTICATED",
}
